import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from '../../service/auth.service';

@Component({
  selector: 'app-signup',
  templateUrl: './signup.component.html',
  styleUrls: ['./signup.component.css']
})
export class SignupComponent implements OnInit {

  firstname: string;
  lastname: string;
  email: string;
  password: string;

  agreed: boolean;

  constructor(
    public authService: AuthService,
    private router: Router) { }

  ngOnInit() {
  }

  tryCreate() {
    this.authService.createNewUser(this.email.toLocaleLowerCase(), this.password, this.firstname, this.lastname)
      .then(res => {
      }, err => {
      });
  }

  accepted(event) {

  }

}
